import { createReducer } from '@reduxjs/toolkit';
import { evaluatedQuestionAction } from './action';
import { EvaluatedQuestionState } from './model';
import { defaultState } from './const';

const initialState: EvaluatedQuestionState = {
  listFilters: defaultState.listFilters,
  selectedFilters: defaultState.selectedFilters,
  maxLengthFilters: defaultState.maxLengthFilters,
  oldSelectedFilters: defaultState.oldSelectedFilters,
};

const evaluatedQuestionReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(evaluatedQuestionAction.setListFilters, (state, action) => {
      state.listFilters = action.payload;
    })
    .addCase(evaluatedQuestionAction.setSelectedFilters, (state, action) => {
      state.selectedFilters = action.payload;
    })
    .addCase(evaluatedQuestionAction.setMaxLengthFilters, (state, action) => {
      state.maxLengthFilters = action.payload;
    })
    .addCase(evaluatedQuestionAction.setOldSelectedFilters, (state, action) => {
      state.oldSelectedFilters = action.payload;
    })
    .addCase(evaluatedQuestionAction.resetState, (state, action) => {
      state.listFilters = defaultState.listFilters;
      state.selectedFilters = defaultState.selectedFilters;
      state.maxLengthFilters = defaultState.maxLengthFilters;
      state.oldSelectedFilters = defaultState.oldSelectedFilters;
    })
);

export default evaluatedQuestionReducer;
